import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useIsHongKongIp } from '../../hooks/useIsHongKongIp';

type NonHongKongRouteProps = {
  children: ReactNode;
};

export default function NonHongKongRoute({ children }: NonHongKongRouteProps) {
  const { ready, canShowRestrictedContent } = useIsHongKongIp();

  // Fail-open: render immediately while the IP lookup is pending or unavailable.
  // A confirmed Hong Kong or United States result redirects the visitor back to the home page.
  if (ready && !canShowRestrictedContent) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
